"use client"
import React from "react"
import clsx from "clsx"
import ExtendedMobile from "../EntendedMobile"
import Branding from "../../Branding"
import { BrandingType, NavigationType } from "@/libs/types"

type BurgerProps = {
    active: boolean
    navigation: Array<NavigationType>
}

const Burger: React.FC<{ className: string, navigation?: any, locale: string, brand: BrandingType }> = ({ className, navigation = [], locale, brand }) => {
    const [mobile, setMobile] = React.useState<BurgerProps>({ active: false, navigation: navigation })

    const handlerClick = () => setMobile((prev: BurgerProps) => ({ ...prev, active: !prev.active }))

    return (
        <>
            <div className="d-flex justify-content-between my-auto d-lg-none d-inline-block">
                <Branding brand={brand} locale={locale} />
                <div className={clsx("burger", !!mobile.active ? "open" : "", className)} onClick={handlerClick}>
                    <span />
                    <span />
                    <span />
                </div>
            </div>
            {!!mobile.active && <ExtendedMobile
                navigations={navigation}
                locale={locale}
                handleClose={() => setMobile((prevState: any) => ({ ...prevState, active: false }))}
            />}
        </>
    )
}

export default Burger
